import { create } from 'zustand';

export type SyncPhase = 'idle' | 'syncing' | 'offline' | 'error' | 'signed-out' | 'disabled';

interface SyncState {
  phase: SyncPhase;
  /** Local changes not yet accepted by the server. */
  pending: number;
  lastSyncAt: string | null;
  lastError: string | null;
  set: (patch: Partial<Omit<SyncState, 'set'>>) => void;
}

export const useSyncStatus = create<SyncState>()((set) => ({
  phase: 'disabled',
  pending: 0,
  lastSyncAt: null,
  lastError: null,
  set: (patch) => set(patch),
}));

export const setSyncStatus = (patch: Partial<Omit<SyncState, 'set'>>): void =>
  useSyncStatus.getState().set(patch);
